import React from 'react';
import styled from 'styled-components';

type Props = {
  children?: React.ReactNode;
};

const Text = styled.h4`
  font-size: 30px;
  margin-bottom: 30px;
  text-align: center;

  @media only screen and (max-width: 680px) {
    font-size: 17px;
    padding: 0 10px;
  }
`;
export const ContentTitle: React.FC<Props> = ({ children }) => {
  return <Text>{children}</Text>;
};
